import { Link } from "react-router-dom";
import { FaHome } from "react-icons/fa";

const HomeButton = () => {
    

    return (
        
        <div align="center">            
            <Link to="/">
                <FaHome
                    title='Menu Principal'
                    style={{ fontSize: "32px" }}                                        
                    onMouseOver={({ target }) => target.style.color = "#515860"}
                    onMouseOut={({ target }) => target.style.color = "white"}
                />
            </Link>                      
        </div>

    )
}

export default HomeButton;